import { useState } from "react";

export type FeedbackReason = "unclear" | "not_credible" | "biased" | "other" | "";

export interface FeedbackFormData {
  reason: FeedbackReason;
  otherText: string;
  details: string;
}

interface UseFeedbackModalResult {
  reason: FeedbackReason;
  setReason: (r: FeedbackReason) => void;
  otherText: string;
  setOtherText: (t: string) => void;
  details: string;
  setDetails: (d: string) => void;
  formData: FeedbackFormData;
  reset: () => void;
}

export function useFeedbackModal(): UseFeedbackModalResult {
  const [reason, setReason] = useState<FeedbackReason>("");
  const [otherText, setOtherText] = useState("");
  const [details, setDetails] = useState("");

  function reset() {
    setReason("");
    setOtherText("");
    setDetails("");
  }

  return {
    reason,
    setReason,
    otherText,
    setOtherText,
    details,
    setDetails,
    formData: { reason, otherText, details },
    reset,
  };
}
